<template>
    <div>
        <div v-if="bill.state === 'COMPLETED'">
            <h3 class="text-5 text-center mb-3">Bundle Purchase Receipt</h3>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Network : </p>
                <p class="col-sm-8 text-uppercase"><strong>{{ bill.network }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Message : </p>
                <p class="col-sm-8"><strong>{{ bill.ReplyMsg }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Recharge ID : </p>
                <p class="col-sm-8"><strong>{{ bill.RechargeID }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Beneficiary : </p>
                <p class="col-sm-8"><strong>{{ bill.account }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Amount : </p>
                <p class="col-sm-8"><strong>USD {{ bill.rated_amount }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8">{{ payment.ecocash_reference }}</p>
            </div>
        </div>
        <div v-if="init || bill.state === 'GENERATING-AIRTIME'">
            <h3 class="text-5 text-center mb-5">Purchasing Bundle ... </h3>
            <div
                class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Your Payment was successful we are recharging your bundle</p>
            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
        </div>
        <div v-if="bill.state === 'AIRTIME-FAILED'">
            <h3 class="text-5 text-center mb-5">Bundles Purchase Receipt</h3>

            <p class="text-center text-danger text-4 mb-5">
                Oops! Looks like the Bundles system is a little unstable right now and your recharge may take longer to
                be delivered. You do not have to do anything. You will receive the recharge as soon as it becomes
                available. This usually takes at most 1 hour. Contact Magetsi Support if you need any assistance.
            </p>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8">{{ payment.ecocash_reference }}</p>
            </div>

            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-6">
                    <button @click.prevent="submit"
                            :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                    </button>
                </div>
                <div class="col-md-6">
                    <router-link to="/bundles" class="btn btn-outline-primary btn-block">Close</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ecocash.vue",
    data() {
        return {
            bill: {},
            payment: {},
            transaction: {},
            loading: false,
            init: true,
            countDown: 5,
            ref: this.$route.query.id
        };

    },
    methods: {
        submit() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/airtime/complete`, {
                ref: this.ref
            }).then((response) => {

                this.init = false;
                if (response.data.success) {
                    this.bill = response.data.body.bill;
                    this.payment = response.data.body.payment;
                    this.transaction = response.data.body.transaction;
                    if (this.bill.state === 'GENERATING-AIRTIME') {
                        this.countDown = 30;
                        this.startCountDown();
                    }
                }

            }).finally(() => {
                this.loading = false;
            });


        },
        startCountDown() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);

            } else {

                if (!this.loading && !this.done) {
                    this.submit();
                }
            }
        },
    },

    mounted() {
        this.submit();
    }
}
</script>

<style scoped>

</style>
